import { useParam } from './useParam';

export function useOptionalProjectKey() {
  const projKey = useParam('projKey', { optional: true });
  const projectKeyParam = useParam('projectKey', { optional: true });
  return projKey ?? projectKeyParam;
}
